module.exports = __webpack_public_path__ + "static/houses_night_mobile-63e71ce4a4b10d8b4120f86b3238474f.jpg";